import { TTranscription } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentDetailCard/components/BroadcastScheduleProgramBodySegmentDetailCardBodySegmentTranscription';
import { TASRRecognitionResult, TBaseItemMention } from '@/features/segments/types';

type TTranscriptionSlate = {
  type: 'timedText';
  transcriptionId: string;
  mentions: TBaseItemMention[];
  children: TASRRecognitionResult[];
};

export const transcriptionToSlateValue = (transcription: TTranscription): TTranscriptionSlate[] => {
  if (!transcription) return [];

  const { words, id, mentions } = transcription;

  return words.map((word: TASRRecognitionResult) => ({
    type: 'timedText',
    transcriptionId: id,
    mentions: mentions,
    children: [
      {
        text: word.text + ' ',
        id: word.id,
        startOffset: word.startOffset,
        endOffset: word.endOffset,
        speakerLabel: word?.speakerLabel || 'S1',
      },
    ],
  }));
};

export function getSecondsFromStart(datetime, videoStartDatetime) {
  if (!datetime || !videoStartDatetime) return 0;
  return (new Date(datetime).getTime() - new Date(videoStartDatetime).getTime()) / 1000;
}
